<div class="role-icons">
    <mat-grid-list cols="3" rowHeight="{{58 | px2rem}}" [gutterSize]="48 | px2rem">
        <mat-grid-tile>
            <div class="icon">
                <div class="rb rb-icon-admin"></div>
            </div>
            <div class="description">
                Admin
                <div class="secondary-title">
                    Can set other admins & create client level roles
                </div>
            </div>
        </mat-grid-tile>
        <mat-grid-tile>
            <div class="icon">
                <div class="rb rb-icon-person"></div>
            </div>
            <div class="description">
                Standard
                <div class="secondary-title">
                    Can access entire account
                </div>
            </div>
        </mat-grid-tile>
        <mat-grid-tile>
            <div class="icon">
                <div class="rb rb-icon-external-user"></div>
            </div>
            <div class="description">
                External
                <div class="secondary-title">
                    Limited advertiser access
                </div>
            </div>
        </mat-grid-tile>
    </mat-grid-list>

</div>
